import { z } from "zod/v4";

const containsOnlyCharactersFromBasicMultilingualPlane = (str: string) =>
  [...str].every((char) => char.codePointAt(0)! <= 0xffff);

const hasExcessiveCombining = (str: string) =>
  /[\u0300-\u036F]{4,}/.test(str) ||
  (str.match(/[\u0300-\u036F]/g) || []).length > 5;

const hasDistortionCharacters = (str: string) =>
  // eslint-disable-next-line no-misleading-character-class
  /[\u202E\u200E\u200F\u034F\u202A-\u202E]/.test(str);

export const CleanString = z
  .string()
  .trim()
  .nonempty()
  .refine((value) => containsOnlyCharactersFromBasicMultilingualPlane(value), {
    message: "Contains invalid characters",
  })
  .refine((value) => !hasExcessiveCombining(value), {
    message: "Contains excessive combining marks (Zalgo)",
  })
  .refine((value) => !hasDistortionCharacters(value), {
    message: "Contains suspicious control characters",
  });
